import { render, staticRenderFns } from "./ValueProposition.vue?vue&type=template&id=0a9692bb&scoped=true&"
import script from "./ValueProposition.vue?vue&type=script&lang=js&"
export * from "./ValueProposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9692bb",
  null
  
)

export default component.exports